import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { products, categories } from '../data/products';

const levelColors = {
  1: { bg: '#f3f4f6', color: '#6b7280', label: 'Giriş' },
  2: { bg: '#dcfce7', color: '#15803d', label: 'Standart' },
  3: { bg: '#dbeafe', color: '#1d4ed8', label: 'Gelişmiş' },
  4: { bg: '#fef2f2', color: '#dc2626', label: 'Premium' },
};

const CategoryPage = ({ forcedCategory }) => {
  const { categoryId: paramCategoryId } = useParams();
  const categoryId = forcedCategory || paramCategoryId;
  const navigate = useNavigate();
  const cat = products[categoryId];

  if (!cat) {
    return (
      <div style={{ padding: '10rem 2rem', textAlign: 'center' }}>
        <h2>Kategorı bulunamadı</h2>
        <Link to="/" className="btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>Ana Sayfaya Dön</Link>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>{cat.title} | NetTest Endüstriyel Testere Solutions</title>
        <meta name="description" content={cat.subtitle} />
        <link rel="canonical" href={`https://nettesttestere.com/urunler/${categoryId}`} />
      </Helmet>

      {/* Sayfa Başlığı */}
      <div className="page-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Anasayfa</Link>
            <span>/</span>
            <span>{cat.title}</span>
          </div>
          <h1>{cat.title}</h1>
          <p>{cat.subtitle}</p>
        </div>
      </div>

      {/* Yan menü + İçerik */}
      <div className="container page-layout">
        {/* SOL: Kategori Navigasyonu */}
        <aside className="page-sidebar">
          <h4 className="sidebar-title">Ürün Kategorileri</h4>
          <ul className="sidebar-menu">
            {categories.map(c => (
              <li key={c.id}>
                <Link
                  to={c.path}
                  className={`sidebar-link ${c.id === categoryId ? 'active' : ''}`}
                >
                  {c.label}
                </Link>
              </li>
            ))}
          </ul>
        </aside>

        {/* SAĞ: Ürün Listesi */}
        <main className="page-content">
          {cat.seoContent && (
            <div className="category-seo-content" dangerouslySetInnerHTML={{ __html: cat.seoContent }} />
          )}

          {cat.groups.map((group, gi) => (
            <div key={gi} className="category-section">
              <div className="category-group-title">{group.label}</div>
              <div className="model-grid">
                {group.items.map((item) => {
                  const lvl = levelColors[item.level] || levelColors[2];
                  return (
                    <div
                      key={item.id}
                      className="model-card"
                      onClick={() => navigate(`/urunler/${categoryId}/${item.id}`)}
                    >
                      <div className="model-card-inner">
                        <div className="model-card-top">
                          <div className="model-saw-icon">
                            <i className="fa-solid fa-gear fa-spin-pulse"></i>
                          </div>
                          <span
                            className="model-level-badge"
                            style={{ background: lvl.bg, color: lvl.color }}
                          >
                            {lvl.label}
                          </span>
                        </div>
                        <h3 className="model-name">{item.name}</h3>
                        <p className="model-tagline">{item.tagline}</p>
                        <div className="model-specs-preview">
                          {item.specs.slice(0, 2).map((s, i) => (
                            <div className="msp-row" key={i}>
                              <span className="msp-label">{s.label}</span>
                              <span className="msp-value">{s.value}</span>
                            </div>
                          ))}
                        </div>
                        <div className="model-cta">
                          Detaylı Bilgi <i className="fa-solid fa-arrow-right"></i>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          {/* Uzmanla Konuş CTA */}
          <div className="category-bottom-cta">
            <h3>Aradığınız modeli bulamadınız mı?</h3>
            <p>Uzman ekibimiz malzemenize en uygun testereyi belirlemeniz için size yardımcı olmaya hazır.</p>
            <a href="https://wa.me/905470013478" target="_blank" rel="noopener noreferrer" className="btn-primary">
              <i className="fa-brands fa-whatsapp"></i> Teknik Danışmanlık Alın
            </a>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CategoryPage;
